export default "__VITE_ASSET__Y6_HyjSK__"